import './index.scss';
import { ApolloProvider } from '@apollo/client';
import {
  AuthProvider,
  HandledLinksProvider,
  loadHeaderCustomComponent,
  theme,
} from '@custom/dx3';
import { ThemeProvider } from '@mui/material/styles';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import { client, setApolloToken } from './store/apollo';
import { AUTH_ENVIRONMENT } from './utils/config/AUTH_ENVIRONMENT';
import { LOGOUT_TIME } from './utils/config/LOGOUT_TIME';

const el = document.getElementById('root');

if (el) {
  const root = createRoot(el);

  loadHeaderCustomComponent(AUTH_ENVIRONMENT).then(() => {
    const handledRegex = new RegExp(
      '^https://xfinitydle(qa|pprd)?.performnet.com/#?'
    );

    root.render(
      <AuthProvider
        logoutTimeInMs={LOGOUT_TIME}
        onTokenUpdate={setApolloToken}
        authEnvironment={AUTH_ENVIRONMENT}
        onLogout={client.clearStore}
        clientId={'dle'}
        redirectURI={window.location.origin}
      >
        <StrictMode>
          <BrowserRouter>
            <HandledLinksProvider regExPattern={handledRegex}>
              <ApolloProvider client={client}>
                <ThemeProvider theme={theme}>
                  <App />
                </ThemeProvider>
              </ApolloProvider>
            </HandledLinksProvider>
          </BrowserRouter>
        </StrictMode>
      </AuthProvider>
    );
  });
} else {
  console.error('could not find root element.');
}
